"use client";

import { Checkbox } from "@mantine/core";
import styles from "./HVCheckbox.module.css";
import HVText from "../HVText/HVText";
import IHVCheckboxProps from "./IHVCheckboxProps";

const HVCheckbox = ({
  checked,
  label,
  disabled,
  onChange,
  defaultChecked,
  labelProps,
  size = "16",
  indeterminate,
  hvCheckboxProps,
}: IHVCheckboxProps) => {
  return (
    <Checkbox
      size={size}
      label={
        label ? (
          <HVText
            style={{ lineHeight: `${size}px` }}
            c={
              disabled
                ? "var(--hv-text-normal-disabled)"
                : "var(--hv-text-normal-primary)"
            }
            type="Body-sm"
            {...labelProps}
          >{`${label}`}</HVText>
        ) : null
      }
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      indeterminate={indeterminate}
      defaultChecked={defaultChecked}
      classNames={styles}
      {...hvCheckboxProps}
    />
  );
};

export default HVCheckbox;
